import React from 'react'
import PropTypes from 'prop-types'

import {
  getActiveThoughtLeaderships,
  getActiveTopics,
} from '../Helper/helper.js'

import InsightsThoughtLeadership from './InsightsThoughtLeadership.jsx'
import InsightsTopics from './InsightsTopics.jsx'

import './insights.css'

function Insights({
  subscriptions,
  wholesalerLabels,
  thoughtLeadershipSuccess,
  topicSuccess,
  userSubscriptionProfile,
  handleSubscribe,
}) {
  const activeThoughtLeaderships = getActiveThoughtLeaderships(subscriptions)
  const activeTopics = getActiveTopics(subscriptions)

  return (
    subscriptions.length > 0 && (
      <React.Fragment>
        <hr className="Rule u-textColorBrand" />
        <div
          id="Insights"
          className="Card u-lg-sizeConstrained u-marginBottom4gu u-bgColorWhite u-sm-paddingHoriz3gu u-sm-paddingVert6gu u-sm-marginBottom6gu"
        >
          <h2 className="u-marginBottom6gu">Insights</h2>
          <InsightsThoughtLeadership
            success={thoughtLeadershipSuccess}
            thoughtLeaderships={activeThoughtLeaderships}
            wholesalerLabels={wholesalerLabels}
            userSubscriptionProfile={userSubscriptionProfile}
            handleSubscribe={handleSubscribe}
          />
          {activeTopics && activeTopics.length > 0 && (
            <hr
              className="Rule Rule--thin u-marginVert6gu"
              role="presentation"
            />
          )}
          <InsightsTopics
            success={topicSuccess}
            topics={activeTopics}
            handleSubscribe={handleSubscribe}
          />
        </div>
      </React.Fragment>
    )
  )
}

Insights.propTypes = {
  subscriptions: PropTypes.array.isRequired,
  wholesalerLabels: PropTypes.array.isRequired,
  userSubscriptionProfile: PropTypes.object.isRequired,
  thoughtLeadershipSuccess: PropTypes.bool,
  topicSuccess: PropTypes.bool,
  insightSuccess: PropTypes.bool,
  handleSubscribe: PropTypes.func.isRequired,
}

export default Insights
